"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStates = void 0;
const Language_1 = require("../../lang/Language");
class PlayerStates {
    static isWaiting(s) {
        return s.tag === 'waiting';
    }
    static isInPlay(s) {
        return s.tag === 'inplay';
    }
    static isFolded(s) {
        return s.tag === 'folded';
    }
    static isAllIn(s) {
        return s.tag === 'allin';
    }
    static isOut(s) {
        return s.tag === 'out';
    }
    static isForeverOut(s) {
        return s.tag === 'foreverout';
    }
    static isDisconnected(s) {
        return s.tag === 'disconnected';
    }
    static isObserver(s) {
        return s.tag === 'observer';
    }
}
exports.PlayerStates = PlayerStates;
PlayerStates.Waiting = {
    tag: 'waiting',
    description: Language_1.Language.strings.states.player.waiting,
};
PlayerStates.InPlay = {
    tag: 'inplay',
    description: Language_1.Language.strings.states.player.inplay,
};
PlayerStates.Folded = {
    tag: 'folded',
    description: Language_1.Language.strings.states.player.folded,
};
PlayerStates.AllIn = {
    tag: 'allin',
    description: Language_1.Language.strings.states.player.allin,
};
PlayerStates.Out = {
    tag: 'out',
    description: Language_1.Language.strings.states.player.out,
};
PlayerStates.ForeverOut = {
    tag: 'foreverout',
    description: Language_1.Language.strings.states.player.foreverOut,
};
PlayerStates.Disconnected = {
    tag: 'disconnected',
    description: Language_1.Language.strings.states.player.disconnected,
};
PlayerStates.Observer = {
    tag: 'observer',
    description: Language_1.Language.strings.states.player.observer,
};
//# sourceMappingURL=PlayerState.js.map